export { default, getStaticProps } from 'containers/ContactPage/ContactPage';
